import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import Divider from '@atoms/Divider/Divider';
import { useLocale } from '@hooks';
import Link from '@components/Link';
import './_Nav.scss';
import Icon from "@atoms/Icon/Icon";
import { IconShare } from "@atoms/Icon/list";
import { AnalyticsEventType } from '../../context/TrackingProvider';
import { useTracking } from '../../hooks';

function NavFooter() {
    const { t } = useTranslation();
    const { getAppLinkWithCurrentLang, currentLanguage } = useLocale();
    let mod_class = ['NavFooter'];
    mod_class = mod_class.join(' ');

    const { track } = useTracking();

    return (
        <nav className={mod_class}>
            <Link
                to="/approach/"
                className="Nav--item"
                activeClassName="is-active"
            >
                {t('nav.label.approach')}
            </Link>
            <Link
                to="/inspiration/"
                className="Nav--item"
                activeClassName="is-active"
            >
                {t('nav.label.stories')}
            </Link>
            <Link
                to="/coverage/"
                className="Nav--item"
                activeClassName="is-active"
            >
                {t('nav.label.coverage')}
            </Link>
            <Link
                to="/about/"
                className="Nav--item"
                activeClassName="is-active"
            >
                {t('nav.label.about.us')}
            </Link>

            <div className="HeaderNav--has-item-inside">
                <Link
                    to="/jobs/"
                    className="Nav--item"
                    activeClassName="is-active"
                >
                    {t('nav.label.jobs')}
                </Link>
                {/* <Badge variant="pink" size="xs" type="callout">
                    Hiring
                </Badge> */}
            </div>

            <Link to="/faq/" className="Nav--item" activeClassName="is-active">
                {t('nav.label.faq')}
            </Link>

            <Divider theme="white" spacing="xxs" />

            <Link
                to="/for-therapists/"
                className="Nav--item"
                activeClassName="is-active"
            >
                {t('nav.label.join.as.psychologist')}
            </Link>

            <Divider theme="white" spacing="xxs" />

            <a
                href={`${process.env.GATSBY_AEPSY_B2B_URL}/${currentLanguage}`}
                target="_blank"
                rel="noreferrer"
                className="Nav--item Nav--external-link-with-icon"
                onClick={() => {
                    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search)?.entries() || []);
                    track({
                        eventType: AnalyticsEventType.GButtonClick,
                        data: {
                            buttonName: "footer_navigation",
                            sourceUrl: window.location.pathname,
                            targetUrl: `${process.env.GATSBY_AEPSY_B2B_URL}/${currentLanguage}`,
                            ...queryParams,
                        },
                    });
                }}
            >
                {t("nav.label.for.partners")}
                <Icon icon={<IconShare />} theme="white" size="xxs" variant="outlined" />
            </a>

            <Divider theme="white" spacing="xxs" />
            <a
                className="Nav--item"
                href={getAppLinkWithCurrentLang('https://app.aepsy.com/login')}
                target="_blank"
                rel="noreferrer"
            >
                {t('nav.label.login')}
            </a>
        </nav>
    );
}

export default NavFooter;
